<template>
    <div class="container">
        <legend>貸し本棚ガイドライン</legend>
        <div class="rule">
            <h3>ガイドラインとは</h3>
            <div class="mb-3">
                ガイドラインは、利用規約以外に定められるサービス利用の指針です。<br>
                違反された場合、警告、公開停止、アカウントの停止などの措置が取られることがあります。
            </div>
        </div>
        <div class="rule">
            <h3>サービス</h3>
            <h4>宣伝・勧誘行為</h4>
            <div class="mb-3">
                作品、あるいは感想機能を利用して、サービス内で読者あるいは作者に対して、作品の感想とは無関係な宣伝、勧誘行為を行うことは禁止されています。<br>
                宣伝や勧誘を受けた場合は、運営までご連絡ください。<br>
                これらの行為が発覚した場合、無警告でのアカウント停止が行われます。
            </div>
            <h4>感想を要求する行為</h4>
            <div class="mb-3">
                作品、あるいは感想機能を利用して、読者あるいは他の作者に対して感想を求める行為は禁止しています。<br>
                <b>「続きが読みたい場合は感想ください」と本文の最後に記述する等。</b><br>
                上記のようなケースでは書籍の公開停止が行われることがあります。
            </div>
            <h4>アカウントの譲渡</h4>
            <div class="mb-3">
                第三者にアカウントを貸与、共有、譲渡することはできません。<br>
                何らかの事情により、アカウントの譲渡が必要になった場合は、お問い合わせから運営までご連絡ください。
            </div>
            <h4>活動のないアカウントの削除</h4>
            <div class="mb-3">
                最後にログインしてから３ヶ月以上経過し、かつ書籍や感想などの投稿が無いアカウントは、安全性の問題から削除されることがあります。
            </div>
            <h3>作品</h3>
            <h4>R15に関して</h4>
            <div class="mb-3">
                R15の判断基準は以下のとおりです。
                <ul>
                    <li>性交、性的接触等の性的感情を刺激する行為を<em>想起させる</em>描写。</li>
                    <li>身体欠損や大量出血、過度の暴力を<em>想起させる</em>描写。</li>
                    <li>違法・過剰な薬物使用、推奨の描写。</li>
                    <li>残虐行為、虐待、いじめ、自傷行為、殺人、窃盗、詐欺、など、明確に法を逸脱する行為に関する配慮の無い描写。</li>
                </ul>
                15歳未満の年少者が閲覧するのにふさわしくない描写が含まれる場合で、
                かつR18には該当しない場合にこのレーティングを設定してください。
            </div>
            <h4>R18に関して</h4>
            <div class="mb-3">
                R18の判断基準は以下のとおりです。
                <ul>
                    <li>性交、性器、性的接触等の性的感情を刺激する行為の描写。</li>
                    <li>身体欠損や大量出血、過度の暴力の描写。</li>
                    <li>なおかつ、性描写、暴力描写を作品の主題としていないもの。</li>
                </ul>
                18歳未満の未成年者が閲覧するのにふさわしくない描写がふくまれるが、
                それ自体を主題としていない作品にはこのレーティングを設定してください。
            </div>
            <h4>XXXに関して</h4>
            <div class="mb-3">
                XXXとはR18に該当し、なおかつそれらの描写を主題とする作品が該当します。<br>
                R18かXXXかわからない場合、XXXのレーティングにすることを推奨します。
                R18の状態で読者から通報があり、XXXにレーティング変更が行われた場合、書籍の評価係数が下がることがあります。
            </div>
            <h4>表紙画像について</h4>
            <div class="mb-3">
                <ul>
                    <li>R18作品であっても、性器、性交、過度の暴力を描写した表紙画像を投稿することはできません。</li>
                    <li>著作権・肖像権を侵害する画像は投稿できません。</li>
                </ul>
            </div>
            <h4>未完作品の完結</h4>
            <div class="mb-3">
                未完状態の作品を完結扱いとし、その先を他のサイトや書籍を読まないとわからない状態にすることはできません。
                また、明らかに未完成の作品を完結作品としたり、連載中と完結を何度も切り替える行為を禁じています。
                これらの行為が発覚した場合、作品の評価係数を下げられることがあります。
            </div>
            <h4>歌詞転載について</h4>
            <div class="mb-3">
                歌詞の転載は著作権の侵害にあたり、全面的に禁止しています。<br>
                著作権の保護期間が経過しているものについては例外となります。
            </div>
            <h4>小説以外の投稿について</h4>
            <div class="mb-3">
                小説以外のエッセイ、随筆、評論等であっても、ガイドラインに違反しない限りは認めています。<br>
                作品の内容によっては、著作権侵害となってしまうケースも御座いますので、ご注意ください。
            </div>
            <h4>記事リンクについて</h4>
            <div class="mb-3">
                外部記事へのリンク機能によって、他人のコンテンツにリンクすることは禁止しています。
                ご自身が作成した記事の中で、外部記事へリンクすることは問題ありません。
            </div>
            <h4>嵩増しの禁止</h4>
            <div class="mb-3">
                小説本文に無意味で過剰な繰り返しを多用することで、文字数を嵩増しすることを禁止しています。
                必要性の認められない過剰な嵩増しと判断された場合、作品の評価係数を下げられることがあります。
            </div>
            <h3>サブドメイン</h3>
            <h4>確保の禁止</h4>
            <div class="mb-3">
                サブドメインを取得して、作品を投稿せずに一定期間が経過すると、そのサブドメインは削除されることがあります。
                作品を投稿される直前にサブドメインを取得することをお勧めします。
            </div>
            <h4>譲渡・売買の禁止</h4>
            <div class="mb-3">
                確保したサブドメインを譲渡、売買することは禁止されています。
                これらの行為が発覚した場合、譲渡元、譲渡先共にアカウントが抹消され、取得不能ドメインに設定されることがあります。
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.rule {
    margin: 1rem 0;
    h3 {
        font-size: 1.3rem;
        border-bottom: 1px dashed #ddd;
        margin: .7rem 0;
        padding: .5rem 0;
    }
    h4 {
        font-size: 1.1rem;
    }
}
</style>

<script>
export default {
    mounted() {
        this.useHead({
            title: "ガイドライン | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>